module.exports = __webpack_public_path__ + "4a85dfece9ddf0fc456bdb585350f8ba.pdf";